import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';

import PriorityTask from './priorityTask';

const enhance = compose(
  withNamespaces(['tasks']),
);
export default enhance(PriorityTask);
